import { Component, Injector, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CoreService } from '@app/@core/services/core.service';

export interface SuccessDialog {
  successMsg: string;
  Id: number;
  detailsRoute: string;
  mainRoute: string;
  msgBody: string;
  src: string;
  link?: string;
  price?: number;
  currency?: string;
  buttonText: string;
}

@Component({
  selector: 'app-creation-success-dialog',
  templateUrl: './creation-success-dialog.component.html',
  styleUrls: ['./creation-success-dialog.component.scss'],
  standalone: false,
})
export class CreationSuccessDialogComponent implements OnInit {
  @Input() data: SuccessDialog;
  htmlDirection: string = 'ltr';

  constructor(
    private router: Router,
    private coreService: CoreService,
    private injector: Injector,
  ) {}

  ngOnInit(): void {
    this.htmlDirection = localStorage.getItem('html-dir') || 'ltr';
    try {
      const dialogData = this.injector.get(MAT_DIALOG_DATA) as SuccessDialog;
      if (dialogData) {
        this.data = dialogData;
      }
    } catch {}

    if (this.data instanceof String) {
      this.data.successMsg = this.data.toString();
    }
  }

  viewDetails() {
    window.location.href = `/${this.data.detailsRoute}/${this.data.Id}`;
  }

  closeDialog() {
    this.router.navigateByUrl(`/${this.data.mainRoute}`);
    try {
      this.injector.get(MatDialogRef).close();
    } catch {
      this.coreService.closeDrawer();
    }
  }

  copyUrl(value: string) {
    navigator.clipboard.writeText(value);
  }
}
